import { API_URL } from "./utils";

// IMPORTANT: build URLs against backend origin (not /api)
const BACKEND_ORIGIN = API_URL.replace(/\/api\/?$/, "");

const FALLBACK_IMAGE =
  "https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=1200&q=85";

export const normalizeImageUrl = (url) => {
  if (!url || typeof url !== "string") return FALLBACK_IMAGE;
  const clean = url.trim();
  if (!clean) return FALLBACK_IMAGE;
  if (/^https?:\/\//i.test(clean)) return clean;
  if (clean.startsWith("/")) return `${BACKEND_ORIGIN}${clean}`;
  return `${BACKEND_ORIGIN}/${clean}`;
};

export const listTatlStories = async (limit = 50) => {
  const res = await fetch(`${API_URL}/tatl/stories?limit=${encodeURIComponent(limit)}`);
  const data = await res.json().catch(() => []);
  if (!res.ok) throw new Error(data?.detail || "Failed to load stories");
  return data;
};

export const getTatlStory = async (slugOrId) => {
  const res = await fetch(`${API_URL}/tatl/stories/${encodeURIComponent(slugOrId)}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.detail || "Failed to load story");
  return data;
};
